import LineEyeIcon from 'components/Luxkit/Icons/line/LineEyeIcon'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import Caption from 'components/Luxkit/Typography/Caption'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { OFFER_VIEWS_THRESHOLD } from 'constants/offer'
import React from 'react'

interface Props {
  views: number;
}

function ViewsCountLabel(props: Props) {
  const { views } = props

  if (views < OFFER_VIEWS_THRESHOLD) {
    return null
  }

  return <PromotionLabel variant="default" icon={<LineEyeIcon />}>
    <Caption variant="medium" weight="bold">
      Viewed <FormatDecimal
        value={views}
        notation={views > 10000 ? 'compact' : undefined}
        maximumFractionDigits={views > 10000 ? 1 : undefined}
      /> times in 3 days
    </Caption>
  </PromotionLabel>
}

export default ViewsCountLabel
